import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "./axiosInstance";

const EmailPasswordReset = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");

    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess(false);

        if (!newPassword || !confirmPassword) {
            setError("Both password fields are required.");
            return;
        }

        if (newPassword !== confirmPassword) {
            setError("Passwords do not match.");
            return;
        }

        if (newPassword.length < 12) {
            setError("Password must be at least 12 characters. See https://xkcd.com/936 for tips.");
            return;
        }

        try {
            setLoading(true);
            const response = await api.post("/auth/reset-password", {
                token, // Send the reset token to verify identity
                newPassword,
            });

            setSuccess(response.data.message || "Password reset successful! You can now log in.");
            setTimeout(() => navigate("/signin"), 500); // Redirect after success
        } catch (err) {
            setError(err.response?.data?.error || "Error resetting password.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-darkblue text-lightgray">
            <div className="w-full max-w-md bg-bluegray shadow-lg rounded-lg p-6">
                <h1 className="text-3xl font-bold text-center text-orange mb-6">Reset Password</h1>

                {error && <div className="bg-red text-white text-sm p-2 rounded mb-4">{error}</div>}
                {success && <div className="bg-green text-white text-sm p-2 rounded mb-4">{success}</div>}

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label htmlFor="newPassword" className="block text-sm font-medium mb-1">
                            New Password
                        </label>
                        <p className="text-xs text-gray-400 mb-1">
                            Minimum 12 characters. <a href="https://xkcd.com/936" target="_blank" rel="noopener noreferrer" className="text-lightblue underline">Tips for strong passwords</a>
                        </p>
                        <input
                            type="password"
                            id="newPassword"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required
                            minLength={12}
                            className="w-full px-3 py-2 rounded bg-deepblue text-lightgray border border-lightblue focus:ring-orange"
                        />
                    </div>
                    <div>
                        <label htmlFor="confirmPassword" className="block text-sm font-medium mb-1">
                            Confirm Password
                        </label>
                        <input
                            type="password"
                            id="confirmPassword"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                            className="w-full px-3 py-2 rounded bg-deepblue text-lightgray border border-lightblue focus:ring-orange"
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={loading}
                        className={`w-full py-2 px-4 bg-orange text-white font-medium rounded ${
                            loading ? "opacity-50 cursor-not-allowed" : ""
                        }`}
                    >
                        {loading ? "Resetting Password..." : "Confirm Reset"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default EmailPasswordReset;
